module.exports = __webpack_public_path__ + "static/numpy-f2e73834cfe0f9448257a82c9f108e59.svg";